import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  helperText?: string;
  error?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className,
  label,
  helperText,
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-344">
        {label && <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" data-id="element-345">
            {label}
            {props.required && <span className="text-red-500 dark:text-red-400 ml-1" data-id="element-346">*</span>}
          </label>}
        <textarea className={cn('flex min-h-[80px] w-full rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-2 py-1.5 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-colors resize-y', error && 'border-red-500 dark:border-red-500 focus:ring-red-500', className)} ref={ref} {...props} data-id="element-347" />
        {helperText && !error && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400" data-id="element-348">
            {helperText}
          </p>}
        {error && <p className="mt-1 text-sm text-red-500 dark:text-red-400" data-id="element-349">{error}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';